import { SitecoreIds } from 'lib/constants';
import { RuleContext } from '../../rules';
import { WhenCondition } from '../../conditions';
import { RuleConditionData } from '../../serialization';
import { ConditionRule } from 'lib/reviews/types';
import { RulesConstants } from 'lib/constants/rules';

export const TextReviewContainsConditionId =
  SitecoreIds.Settings.Rules.Definitions.Elements.RbA_Reviews.TextReviewContains.ItemId;

export class TextReviewContainsCondition<T extends RuleContext> extends WhenCondition<T> {
  reviewText: string;
  constructor(condition: RuleConditionData) {
    super();
    this.reviewText = condition.reviewText as string;
  }

  execute(ruleContext: T): boolean {
    const conditions: Array<ConditionRule> =
      (ruleContext.parameters[RulesConstants.Parameters.Conditions] as Array<ConditionRule>) ?? [];
    conditions.push({
      propertyName: 'review.reviewText',
      comparison: 'contains',
      value: this.reviewText,
    });
    ruleContext.parameters[RulesConstants.Parameters.Conditions] = conditions;
    return ruleContext.parameters[RulesConstants.Parameters.Operator] ==
      RulesConstants.Operators.And
      ? true
      : false;
  }
}
